import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class VehicleChargeLegacyComponent implements IController {
  program: any;
  groups: any;
  programId: any;
  accountId: any;

  public isDesktop: boolean;
  public groupKeysCopy: any;
  public groupKeys: any;
  public isSaveAvailable: boolean;

  constructor(private PricePlanService, private $mdMedia) {
    this.isDesktop = $mdMedia('gt-md');
  }

  $onInit() {
    this.initValues();
  }

  initValues(){
    this.isSaveAvailable = false;
    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);
    this.groupKeysCopy = angular.copy(this.groupKeys);
  }

  onSelectedChange(vehicleData, vehicleType) {
    this.groupKeys.VehicleFactor[vehicleType].selected = !vehicleData.selected ? null : vehicleData.selected;
    if (vehicleData.selected) {
      _.forOwn(this.groupKeys.VehicleFactor, (value, key) => {
        if (vehicleType !== key) {
          value.selected = false;
        }
      });
    }
    this.onDataChange(this.groupKeys);
  }

  onDataChange(groupKeys) {
    this.isSaveAvailable = !_.isEqual(groupKeys, this.groupKeysCopy);
  }

  onSaveProgram() {
    const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, this.groupKeys);
    this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;
        this.initValues();
      })
  }

  onCancelChanges() {
    this.groupKeys = angular.copy(this.groupKeysCopy);
    this.isSaveAvailable = false;
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanVehicleChargeLegacyView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?'
    },
    template: require('./vehicle-charge-legacy.html').default,
    controller: VehicleChargeLegacyComponent
  });
